import { ThemeConfigPayload, ThemeConfigResponse } from "./theme.model";

/**
 * Maps a loaded `ThemeConfigResponse` back to the write payload (asset keys + PWA fields; the
 * read-only `*Url` fields are dropped). Returns `undefined` when there's nothing to send.
 *
 * The theme update endpoint replaces the whole theme, so an edit that only touches one section
 * (e.g. Responses) must round-trip the other sections or they're nulled out. Until the Display
 * (T-2) / PWA (T-3) tabs manage `themeConfig` in the form, the edit page uses this to preserve it.
 */
export function toThemeConfigPayload(config: ThemeConfigResponse | null | undefined): ThemeConfigPayload | undefined {
    if (!config) return undefined;
    const payload: ThemeConfigPayload = {};
    if (config.tenantLogoAssetKey) payload.tenantLogoAssetKey = config.tenantLogoAssetKey;
    if (config.hostViewWallpaperAssetKey) payload.hostViewWallpaperAssetKey = config.hostViewWallpaperAssetKey;
    if (config.pwaName) payload.pwaName = config.pwaName;
    if (config.pwaNameShort) payload.pwaNameShort = config.pwaNameShort;
    if (config.pwaDescription) payload.pwaDescription = config.pwaDescription;
    if (config.pwaThemeColor) payload.pwaThemeColor = config.pwaThemeColor;
    if (config.pwaBackgroundColor) payload.pwaBackgroundColor = config.pwaBackgroundColor;
    if (config.pwaAppIcon192AssetKey) payload.pwaAppIcon192AssetKey = config.pwaAppIcon192AssetKey;
    if (config.pwaAppIcon512AssetKey) payload.pwaAppIcon512AssetKey = config.pwaAppIcon512AssetKey;
    return Object.keys(payload).length ? payload : undefined;
}
